import { DateTimeRange } from '@modules/common/components/DateRangePicker/types';
import {
  getAggregatePeriodForLowerBucketCountLimit,
  getAggregatePeriodForUpperBucketCountLimit,
} from '@modules/common/utils';
import {
  MAX_DAILY_BUCKET_COUNT_FOR_TREND_CHART,
  MAX_WEEKLY_BUCKET_COUNT_FOR_TREND_CHART,
  MIN_TIME_BUCKET_COUNT_FOR_TREND_CHART,
} from '@modules/quantify/constants';
import { TimeUnit } from 'generated/graphql';

interface GetQuantifyAggregatePeriodFromDurationParams {
  duration: DateTimeRange;
  currentAggregatePeriod: TimeUnit;
}

export const getQuantifyAggregatePeriodFromDuration = ({
  duration,
  currentAggregatePeriod,
}: GetQuantifyAggregatePeriodFromDurationParams) => {
  const aggregatePeriodForUpperBucketCountLimit =
    getAggregatePeriodForUpperBucketCountLimit({
      currentAggregatePeriod,
      dateRange: duration,
      upperBucketCountLimit: {
        weekly: MAX_WEEKLY_BUCKET_COUNT_FOR_TREND_CHART,
        daily: MAX_DAILY_BUCKET_COUNT_FOR_TREND_CHART,
      },
    });

  return getAggregatePeriodForLowerBucketCountLimit({
    currentAggregatePeriod: aggregatePeriodForUpperBucketCountLimit,
    dateRange: duration,
    lowerBucketCountLimit: MIN_TIME_BUCKET_COUNT_FOR_TREND_CHART,
  });
};
